import find from 'lodash/fp/find';
import ACTIVITIES from '../../../node_modules/@suunto/suunto-information-model/Specifications/SuuntoAppConfiguration/activities.json';

export default function getActivityInfo(activityId) {
  return find((activity) => activity.STId === activityId)(ACTIVITIES);
}
